/* §135 mobil görsel penceresi (starqon-custom.css) */
(function () {
var mq = matchMedia('(max-width: 749px)');
document.querySelectorAll('product-modal').forEach(function (m) {
var c = m.querySelector('.product-media-modal__content'); if (!c) return;
var s = document.createElement('div'); s.className = 'sq-zoom-say'; c.parentNode.appendChild(s);
var L = function () { return [].filter.call(c.children, function (e) { return e.hasAttribute('data-media-id'); }); };
var I = function (o) { return o.findIndex(function (e) { return e.classList.contains('active'); }); };
var u = function () { var o = L(); s.textContent = o.length > 1 ? I(o) + 1 + ' / ' + o.length : ''; };
var git = function (y) { var o = L(), i = I(o), j = i + y; if (j < 0 || j >= o.length) return; o[i].classList.remove('active'); o[j].classList.add('active'); u(); };
new MutationObserver(function () { if (m.hasAttribute('open')) { c.classList.remove('sq-z'); u(); } }).observe(m, { attributes: true, attributeFilter: ['open'] });
var x0, y0, t0, son = 0, cok;
c.addEventListener('touchstart', function (e) { cok = e.touches.length > 1; if (cok) return; x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; t0 = Date.now(); }, { passive: true });
c.addEventListener('touchend', function (e) {
if (!mq.matches || cok) return;
var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0, n = Date.now(), z = c.classList.contains('sq-z');
if (!z && Math.abs(dx) > 50 && Math.abs(dy) < 60 && n - t0 < 600) { git(dx < 0 ? 1 : -1); son = 0; return; }
if (Math.abs(dx) > 10 || Math.abs(dy) > 10) return;
if (n - son > 320) { son = n; return; }
son = 0; e.preventDefault();
var g = e.target.closest('[data-media-id]'); if (!g) return;
var r = g.getBoundingClientRect(), rx = (t.clientX - r.left) / r.width, ry = (t.clientY - r.top) / r.height;
c.classList.toggle('sq-z');
if (!z) requestAnimationFrame(function () { c.scrollLeft = rx * g.offsetWidth - c.clientWidth / 2; c.scrollTop = ry * g.offsetHeight - c.clientHeight / 2; });
});
});
})();
